import { NgClass } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NumberSuffixPipe } from '@core/pipes/number-suffix.pipe';
import { PercentagePipe } from '@core/pipes/percentage.pipe';
import { AnalyticsStatusBadgeComponent } from '@shared/components/analytics-status-badge/analytics-status-badge.component';
import { IconBadgeComponent } from '@shared/components/icon-badge/icon-badge.component';
import { StatusBadgeComponent } from '@shared/components/status-badge/status-badge.component';
import { TextClampTooltipDirective } from '@shared/directives/text-clamp-tooltip.directive';
import { ImageUtilitiesService } from '@utilities/image-utilities.service';
import { NumberSeparatorUtilitiesService } from '@utilities/number-separator-utilities.service';
import { PercentageUtilitiesService } from '@utilities/percentage-utilities.service';
import { IKpiCard, TKpiCardLayout } from './cta-analytics-details-kpi-card.interface';

@Component({
  imports: [
    IconBadgeComponent,
    NumberSuffixPipe,
    MatTooltipModule,
    StatusBadgeComponent,
    PercentagePipe,
    AnalyticsStatusBadgeComponent,
    NgClass,
    TextClampTooltipDirective,
  ],
  selector: 'app-cta-analytics-details-kpi-card',
  templateUrl: './cta-analytics-details-kpi-card.component.html',
})
export class CtaAnalyticsDetailsKpiCardComponent {
  public readonly data = input.required<IKpiCard>();

  public readonly backgroundColor = input<string>('var(--shikenso-blue-100)');
  public readonly titleMaxWidth = input<string | null>(null);
  public readonly layout = input<TKpiCardLayout>('vertical');
  public readonly iconBackgroundColor = input<string>('var(--shikenso-blue-200)');

  public readonly imageUrl = computed(() => {
    const url = this.data().image;

    return url ? ImageUtilitiesService.replaceImageDimensions(url, 92, 124) : null;
  });

  public readonly valueTooltip = computed(() => {
    const { value, isPercentage } = this.data();

    if (isPercentage) {
      return value ? `${this.percentageUtilitiesService.getPercentage(value!, true)}%` : '0%';
    }

    return value ? this.numberSeparatorUtilities.formatNumberToLocaleString(value!, null, 0, 2, true) : '0';
  });

  private readonly percentageUtilitiesService = inject(PercentageUtilitiesService);
  private readonly numberSeparatorUtilities = inject(NumberSeparatorUtilitiesService);
}
